
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class TaskflowTemplateTagConstants {
	static orderWarning: TaskflowTemplateTagConstantsType = 'orderwarning';
	static activateRegistrarManagement: TaskflowTemplateTagConstantsType = 'activateregistrarmanagement';
	static domainPurchase: TaskflowTemplateTagConstantsType = 'domainpurchase';
	static transferDomain: TaskflowTemplateTagConstantsType = 'transferdomain';

	static values = ['orderwarning', 'activateregistrarmanagement', 'domainpurchase', 'transferdomain'];
}
export type TaskflowTemplateTagConstantsType = 'orderwarning' | 'activateregistrarmanagement' | 'domainpurchase' | 'transferdomain';

